import { Tag, TagLabel, TagProps, Tooltip } from "@chakra-ui/react";
import { FunctionComponent } from "react";
import * as FSPR from "src/generated/hooks/form-service-public/requests";

type Props = TagProps & {
  band: FSPR.AvailabilityBandValue;
};

export const BandTag: FunctionComponent<Props> = ({ band, ...tagProps }) => {
  const tag = (
    <Tag
      size="sm"
      variant="subtle"
      colorScheme={band.colorScheme}
      borderRadius="full"
      flex="none"
      {...tagProps}
    >
      <TagLabel>{band.label}</TagLabel>
    </Tag>
  );

  if (band.description === undefined || band.description === "") {
    return tag;
  }

  return (
    <Tooltip label={band.description} hasArrow>
      {tag}
    </Tooltip>
  );
};
